import StarFilledIconPath from "@ingka/ssr-icon/paths/star-filled";

export default StarFilledIconPath;
